<template>
    <div id="wrap">
        <Main/>
        <Steps/>
        <Banks/>
        <Terms/>
        <CreateStmt/>
        <Consultation/>
        <Footer/>
    </div>
</template>

<script>
import Footer from '../components/Footer';
import Main from '../components/blocks/Main';
import Steps from '../components/blocks/Steps';
import Banks from '../components/blocks/Banks';
import Terms from '../components/blocks/Terms';
import CreateStmt from '../components/blocks/CreateStmt';
import Consultation from '../components/blocks/Consultation';

export default {
    components: {
        Footer,
        Main,
        Steps,
        Banks,
        Terms,
        CreateStmt,
        Consultation
    }
}
</script>

<style lang="scss">
#wrap {
    background: rgba(230, 240, 255, 0.3);
}
</style>